import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import orderflowDashboard from "../../Assets/Projects/orderflow-saas-dashboard.png";
import orderflowApi from "../../Assets/Projects/orderflow-api-backend.png";
import orderflowArchitecture from "../../Assets/Projects/orderflow-architecture.png";
import devpulseDashboard from "../../Assets/Projects/devpulse-engineering-dashboard.png";
import devpulseApi from "../../Assets/Projects/devpulse-api-integration.png";
import devpulseArchitecture from "../../Assets/Projects/devpulse-analytics-architecture.png";
import ecommerceMain from "../../Assets/Projects/ecommerce-dashboard-main-thumbnail.png";
import ecommerceFeatures from "../../Assets/Projects/ecommerce-dashboard-features.png";
import ecommerceWorkflow from "../../Assets/Projects/ecommerce-dashboard-workflow-trust.png";
import supportflowDashboard from "../../Assets/Projects/supportflow-dashboard-overview.png";
import supportflowWorkflow from "../../Assets/Projects/supportflow-ai-ticket-workflow.png";
import supportflowArchitecture from "../../Assets/Projects/supportflow-architecture-reporting.png";

const projects = [
  {
    title: "SaaS Order Management Platform",
    role: "Full-Stack Developer",
    gallery: [orderflowDashboard, orderflowApi, orderflowArchitecture],
    skills: ["React", "Node.js", "PostgreSQL", "API Development", "Stripe"],
    description:
      "Built a SaaS-style order management platform for teams that need a clear way to manage orders, billing, reporting, and operational activity from one workspace. The project includes a responsive dashboard UI, backend API flows, role-based access, Stripe billing, audit logs, admin reporting, Docker deployment, and GitHub Actions release support.",
    impact:
      "Strongest full-stack project because it proves product delivery across frontend, backend, payments, reporting, and deployment.",
  },
  {
    title: "Engineering Metrics Dashboard",
    role: "Full-Stack Developer",
    gallery: [devpulseDashboard, devpulseApi, devpulseArchitecture],
    skills: ["Next.js", "React", "TypeScript", "PostgreSQL", "API Integration"],
    description:
      "Built an engineering analytics dashboard for tracking pull-request cycle time, review load, deployment frequency, API data flow, and team delivery signals. The project combines a polished dashboard interface with GitHub API integration, backend data models, PostgreSQL storage, Prisma-style architecture, and clear reporting views for engineering teams.",
    impact:
      "Shows dashboard UX, API integration, data modeling, and analytics thinking for technical product teams.",
  },
  {
    title: "E-commerce Analytics & Inventory Dashboard",
    role: "Full-Stack Developer",
    gallery: [ecommerceMain, ecommerceFeatures, ecommerceWorkflow],
    skills: ["React", "TypeScript", "Dashboard", "Data Visualization", "Responsive Web Design"],
    description:
      "Designed and built a responsive dashboard for ecommerce teams to monitor revenue trends, inventory alerts, product performance, stock movement, and operational reporting. The interface focuses on fast scanning, clear charts, responsive layouts, and practical business decisions.",
    impact:
      "Demonstrates business-facing dashboard design, ecommerce reporting, inventory workflows, and responsive UI execution.",
  },
  {
    title: "SupportFlow AI - Support Automation",
    role: "Full-Stack Developer",
    gallery: [supportflowDashboard, supportflowWorkflow, supportflowArchitecture],
    skills: ["React", "TypeScript", "Node.js", "PostgreSQL", "API Integration"],
    description:
      "Built a support automation concept for AI-powered ticket management, reply suggestions, priority detection, knowledge base lookup, escalation rules, and reporting. The project connects product UI, backend API flows, AI workflow logic, and support analytics into one operational system.",
    impact:
      "Shows AI workflow thinking, customer support automation, backend integration, and SaaS dashboard presentation.",
  },
];

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Selected <strong className="purple">Projects </strong>
        </h1>
        <p className="project-intro">
          A focused set of full-stack web applications, dashboards, APIs, and
          business workflows built around real product outcomes.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {projects.map((project) => (
            <Col lg={6} className="project-card" key={project.title}>
              <ProjectCard {...project} />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
